(function() {
  const syncSliders = () => {
    // 1. Находим все миниатюры
    const thumbSliders = document.querySelectorAll('[data-instant-type="thumbnails"]');

    thumbSliders.forEach((thumbs) => {
      if (thumbs.dataset.processed === 'true') return;

      const sliderId = thumbs.getAttribute('data-instant-slider-id');
      const slides = thumbs.querySelectorAll('.instant-slider-slide');

      slides.forEach((slide, index) => {
        // Добавляем стили прямо через JS, чтобы не лезть в CSS-файл
        slide.style.cursor = 'pointer';
        slide.style.pointerEvents = 'auto';
        slide.style.webkitUserDrag = 'none';
        
        // Защита от того, чтобы картинка не блокировала клик
        const img = slide.querySelector('img');
        if (img) img.style.pointerEvents = 'none';

        slide.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Ищем все главные слайдеры с этим ID (и для десктопа, и для мобилки)
          const mains = document.querySelectorAll(`[data-instant-slider-id="${sliderId}"][data-instant-type="slider"]`);
          
          mains.forEach(main => {
            // Пытаемся переключить через Swiper
            const swiper = main.swiper || main.querySelector('.instant-slider')?.swiper;
            
            if (swiper) {
              swiper.slideToLoop(index);
            } else {
              // Запасной вариант: эмуляция клика по стрелкам, если Swiper недоступен
              const parent = main.closest('.instant-slider-container').parentElement;
              const nextBtn = parent.querySelector('.instant-slider-button-next');
              const prevBtn = parent.querySelector('.instant-slider-button-prev');
              
              if (nextBtn && prevBtn) {
                // Пытаемся определить текущий индекс по активному классу
                const currentActive = thumbs.querySelector('.instant-slider-slide-active, .instant-slider-thumb-active');
                const currentIndex = Array.from(slides).indexOf(currentActive);
                const diff = index - (currentIndex >= 0 ? currentIndex : 0);
                
                for (let i = 0; i < Math.abs(diff); i++) {
                  diff > 0 ? nextBtn.click() : prevBtn.click();
                }
              }
            }
          });

          // Обновляем визуальный вид активной миниатюры
          slides.forEach(s => {
            s.style.opacity = '0.5';
            s.classList.remove('instant-slider-thumb-active');
          });
          slide.style.opacity = '1';
          slide.classList.add('instant-slider-thumb-active');
        };
      });
      
      thumbs.dataset.processed = 'true';
    });
  };

  // Запускаем цикл проверки
  setInterval(syncSliders, 800);
})();